(() => {
  if (window.LmbReviewTopics) { window.LmbReviewTopics.start(document); return; }
  const instances = new Map();
  const cache = new Map();
  const waiting = new Map();
  const languageCache = new WeakMap();
  const languageNames = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'language' });
  const terms = {
    spa: /\b(spa|wellness|sauna|hammam|hamam|relaxation|entspann)/,
    pool_beach: /\b(pool|beach|strand|piscine|plage|schwimm|meer|swim)/,
    travel: /\b(travel|reis|urlaub|holiday|voyage|flieg|flight|koffer|suitcase|rucksack)/,
    gift: /\b(gift|geschenk|verschenk|cadeau|present)/,
    soft: /\b(soft|comfort|weich|angenehm|doux|douce|confort|kratzt nicht|nicht kratzt)/,
    quick_drying: /quick.dry|fast.dry|dry.{0,12}fast|trocken|trockne|trocknet|trocknen|sechage|seche|drying/,
    lightweight: /\b(lightweight|light|leicht|low weight|leger)/,
    absorbent: /\b(absorben|saugfah|saugt|saugkra|saugst|aufnimmt)/,
    durable: /\b(durab|langleb|robust|haltbar|fransen|ausgefranst|fray|wear)|keeps.{0,20}shape|halt.{0,35}wasch|after several washes/,
    machine_washable: /machine.wash|maschinenwasch|waschmaschine|waschbar|washable|lavable|washing|waschen|wasche/,
    quality: /craftsmanship|quality|qualitat|verarbeitung|hochwertig|webart|weave|gewebe|finition/,
    plastic_free_packaging: /plastic.free|plastikfrei|ohne.{0,12}plastik|sans.{0,12}plastique/,
    good_value: /good.value|value.for.money|preis.leistung|preiswert|rapport.qualite|gutes.{0,12}preis/,
    fast_delivery: /fast.delivery|quick.delivery|schnell.{0,20}(liefer|versand|an)|liefer.{0,20}schnell|kam schnell|livraison rapide/,
    worth_price: /worth.{0,12}price|preis.{0,12}wert|preis|price|teuer|prix/,
    beach_bag: /beach.bag|strandtasch|sac.de.plage|beach.{0,35}(bag|pack)|strand.{0,35}(tasch|pack)/,
    yoga: /\byoga\b/,
    pilates: /\bpilates\b/,
    compact: /\b(compact|kompakt|platzspar|klein|falt|fold|platz|space)|\bpack(ed|ing)?\b/
  };
  const abbreviatedName = (value) => {
    const parts = value.trim().split(/\s+/);
    if (parts.length < 2 || /\d/.test(value) || value.includes('@')) return value.trim();
    const surname = parts[parts.length - 1];
    return `${parts[0]} ${Array.from(surname)[0]}.`;
  };
  const formatAuthors = (scope) => {
    formatReviewLanguages(scope);
    scope.querySelectorAll('.jdgm-rev__author, .jdgm-carousel-item__reviewer-name').forEach((author) => {
      const name = abbreviatedName(author.textContent || '');
      if (author.textContent !== name) author.textContent = name;
      if (author.hasAttribute('title')) author.setAttribute('title', name);
    });
  };
  const languageVocabularies = {
      de: 'ich das der die den dem des ein eine einen ist sind war sehr und für mit nicht auch nach meine meiner mein habe haben aber auf zum zur beim sich sie es im mir gefällt schön weich schnell tuch tücher gekauft empfehlung trocknet gut gute toll toller tolle tollem einfach zufrieden diesem kauf empfehlenswert hervorragender kundenservice qualität bin passt perfekt alles liebe angenehm empfehle farben waschen',
      en: 'the this that these those is are was were and for with not also after my have has but on to at it its feels nice soft bought recommend dries really very great love them they',
      fr: 'je le la les des une un est sont et pour avec pas aussi après mon ma mes mais sur très doux douce acheté recommande sèche vraiment serviette bonne bon qualité livraison rapide satisfait recommande cadeau emballage',
      it: 'io il lo gli dei delle una uno sono è con per non anche dopo mio mia miei molto morbido asciuga acquistato consiglio asciugamano',
      es: 'yo el los las del una uno es son y para con no también después mi mis pero muy suave comprado recomiendo seca toalla',
      nl: 'ik het een zijn voor met niet ook mijn maar op erg zacht gekocht droogt handdoek deze',
      pt: 'eu os as dos das uma um são é para com não também após meu minha mas muito macio comprei recomendo toalha'
  };
  const vocabularySets = Object.entries(languageVocabularies).map(([code, words]) => [code, new Set(words.split(' '))]);
  const reviewLanguages = (text, declared = '') => {
    const supported = { de: '🇩🇪', en: '🇬🇧', fr: '🇫🇷', it: '🇮🇹', es: '🇪🇸', nl: '🇳🇱', pt: '🇵🇹' };
    const language = declared.toLowerCase().split(/[-_]/)[0];
    const words = text.toLowerCase().normalize('NFC').match(/\p{L}+/gu) || [];
    const scores = vocabularySets.map(([code, terms]) => {
      return { code, score: words.reduce((sum, word) => sum + Number(terms.has(word)), 0), distinct: new Set(words.filter((word) => terms.has(word))).size };
    }).sort((a, b) => b.score - a.score);
    const best = scores[0].score;
    const detected = scores.filter(({ score, distinct }) => score >= 3 && distinct >= 3 && score >= best * .3).slice(0, 2).map(({ code }) => code);
    if (!detected.length && supported[language]) detected.push(language);
    return detected.map((code) => ({ code, flag: supported[code] }));
  };
  const formatReviewLanguages = (scope) => {
    [...(scope.matches?.('.jdgm-rev, .jdgm-carousel-item') ? [scope] : []), ...scope.querySelectorAll('.jdgm-rev, .jdgm-carousel-item')].forEach((review) => {
      const title = review.querySelector('.jdgm-rev__title, .jdgm-carousel-item__review-title');
      const body = review.querySelector('.jdgm-rev__body, .jdgm-carousel-item__review-body');
      const text = [title?.textContent || '', body?.textContent || ''].join(' ');
      const declared = review.dataset.reviewLanguage || '';
      const signature = `${declared}:${text}`;
      const previous = languageCache.get(review);
      const target = review.querySelector('.jdgm-rev__author-wrapper, .jdgm-carousel-item__reviewer-name-wrapper');
      if (!target) return;
      if (previous?.signature === signature && previous.badge?.isConnected && previous.badge.parentElement === target) return;
      const languages = reviewLanguages(text, declared);
      if (!languages.length) { languageCache.set(review, { signature }); return; }
      const value = languages.map(({ flag }) => flag).join(' ');
      let badge = target.querySelector('.lmb-review-language');
      if (badge?.textContent === value) { languageCache.set(review, { signature, badge }); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lmb-review-language';
        badge.setAttribute('role', 'img');
        target.append(badge);
      }
      const label = languages.map(({ code }) => languageNames.of(code)).join(' / ');
      badge.textContent = value;
      badge.setAttribute('aria-label', label);
      badge.title = label;
      languageCache.set(review, { signature, badge });
    });
  };

  const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const readJson = (section, selector, fallback) => {
    try { return JSON.parse(section.querySelector(selector)?.textContent || 'null') || fallback; }
    catch (_) { return fallback; }
  };
  const fetchProduct = (shop, id) => {
    const key = `${shop}:${id}`;
    if (cache.has(key)) return cache.get(key);
    const task = (async () => {
      let page = 1;
      let totalPages = 1;
      const reviews = new Map();
      do {
        const params = new URLSearchParams({ shop_domain: shop, platform: 'shopify', product_id: id, page: String(page), per_page: '30', sort_by: 'created_at', sort_dir: 'desc' });
        const response = await fetch(`https://api.judge.me/reviews/reviews_for_widget?${params}`, { signal: AbortSignal.timeout(20000), credentials: 'omit' });
        if (!response.ok) throw new Error('Review request failed');
        const data = await response.json();
        if (typeof data.html !== 'string') throw new Error('Invalid review response');
        const doc = new DOMParser().parseFromString(data.html, 'text/html');
        doc.querySelectorAll('.jdgm-rev').forEach((review) => {
          const uuid = review.dataset.reviewId;
          if (!uuid) return;
          review.querySelectorAll('script, style, .jdgm-rev__actions').forEach((node) => node.remove());
          reviews.set(uuid, {
            node: review,
            text: normalize(`${review.querySelector('.jdgm-rev__title')?.textContent || ''} ${review.querySelector('.jdgm-rev__body')?.textContent || ''}`),
            rating: Number(review.querySelector('[data-score]')?.dataset.score || 0),
            date: review.querySelector('time')?.getAttribute('datetime') || '',
            product: review.dataset.productTitle || '',
            url: review.dataset.productUrl || ''
          });
        });
        totalPages = Math.max(1, Math.ceil(Number(data.total_count || 0) / 30));
        page += 1;
      } while (page <= totalPages);
      return [...reviews.values()];
    })();
    cache.set(key, task);
    task.catch(() => cache.delete(key));
    return task;
  };
  const connectTopicDisclosure = (section) => {
    const topics = section.querySelector('.lmb-review-overview__topics');
    const disclosure = topics?.querySelector('.lmb-review-topic-disclosure');
    const primary = topics?.querySelector('.lmb-review-topic-list');
    const extra = disclosure?.querySelector('.lmb-review-topic-list');
    if (!primary || !extra) return () => {};
    const items = [...primary.children, ...extra.children];
    const mobile = window.matchMedia('(max-width: 767px)');
    let frame = null;
    let lastWidth = -1;
    let lastMobile = null;
    let disposed = false;
    const layout = () => {
      frame = null;
      if (disposed) return;
      const width = primary.getBoundingClientRect().width;
      if (!width || (Math.abs(width - lastWidth) < .5 && lastMobile === mobile.matches)) return;
      lastWidth = width;
      lastMobile = mobile.matches;
      const primaryBatch = document.createDocumentFragment();
      items.forEach((item) => primaryBatch.append(item));
      primary.append(primaryBatch);
      let count = 4;
      if (!mobile.matches) {
        const gap = parseFloat(getComputedStyle(primary).columnGap) || 8;
        const widths = items.map((item) => item.getBoundingClientRect().width);
        let used = 0;
        count = 0;
        for (const itemWidth of widths) {
          const needed = itemWidth + (count ? gap : 0);
          if (count && used + needed > width + .5) break;
          used += needed;
          count += 1;
        }
      }
      const extraBatch = document.createDocumentFragment();
      items.slice(count).forEach((item) => extraBatch.append(item));
      extra.append(extraBatch);
      disclosure.hidden = count === items.length;
    };
    const schedule = () => { if (!disposed && frame === null) frame = requestAnimationFrame(layout); };
    const resize = new ResizeObserver(schedule);
    resize.observe(topics);
    mobile.addEventListener('change', schedule);
    document.fonts?.ready.then(() => { lastWidth = -1; schedule(); });
    layout();
    return () => {
      disposed = true;
      resize.disconnect();
      mobile.removeEventListener('change', schedule);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  };

  const connect = (section) => {
    if (instances.has(section)) return;
    const feed = section.querySelector('[data-lmb-review-feed]');
    if (!feed) return;
    const disposeTopicDisclosure = connectTopicDisclosure(section);
    const labels = readJson(section, '[data-lmb-review-filter-labels]', {});
    const countText = (count) => count === 1 ? labels.results_one : labels.results.replace('__COUNT__', count);
    const productId = section.dataset.lmbReviewProduct;
    const shop = section.dataset.lmbReviewShop;
    const isHome = !productId;
    const native = section.querySelector('[data-lmb-review-native]');
    const buttons = [...section.querySelectorAll('[data-lmb-review-topic]')];
    const status = feed.querySelector('[data-lmb-review-status]');
    const results = feed.querySelector('[data-lmb-review-results]');
    const reset = feed.querySelector('[data-lmb-review-reset]');
    const retry = feed.querySelector('[data-lmb-review-retry]');
    const pagination = feed.querySelector('[data-lmb-review-pagination]');
    const previous = feed.querySelector('[data-lmb-review-previous]');
    const next = feed.querySelector('[data-lmb-review-next]');
    const sort = feed.querySelector('[data-lmb-review-sort]');
    const locale = section.dataset.lmbReviewsLocale?.startsWith('de') ? 'de-DE' : 'en-GB';
    const dateFormat = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' });
    let rows = null;
    let selected = '';
    let page = 1;
    let pending = null;
    let disposed = false;
    const render = () => {
      if (!rows || disposed) return;
      if (isHome && !selected) { feed.hidden = true; native.hidden = false; return; }
      feed.hidden = false;
      native.hidden = true;
      const filtered = rows.filter((review) => !selected || terms[selected]?.test(review.text));
      filtered.sort((a, b) => sort.value === 'highest' ? b.rating - a.rating || b.date.localeCompare(a.date) : sort.value === 'lowest' ? a.rating - b.rating || b.date.localeCompare(a.date) : b.date.localeCompare(a.date));
      const pages = Math.max(1, Math.ceil(filtered.length / 5));
      page = Math.min(page, pages);
      status.textContent = filtered.length ? countText(filtered.length) : labels.empty;
      reset.hidden = !selected;
      retry.hidden = true;
      results.replaceChildren();
      filtered.slice((page - 1) * 5, page * 5).forEach((row) => {
        const node = row.node.cloneNode(true);
        formatAuthors(node);
        node.querySelectorAll('time').forEach((time) => {
          time.classList.remove('jdgm-spinner');
          const date = new Date(time.getAttribute('datetime'));
          if (!Number.isNaN(date.valueOf())) time.textContent = dateFormat.format(date);
        });
        if (isHome && row.url.startsWith('/products/')) {
          const link = document.createElement('a');
          link.className = 'lmb-review-feed__product';
          link.href = `${locale === 'de-DE' ? '' : '/en'}${row.url}`;
          link.textContent = row.product || labels.product;
          node.append(link);
        }
        results.append(node);
      });
      pagination.hidden = pages < 2;
      previous.disabled = page <= 1;
      next.disabled = page >= pages;
      feed.querySelector('[data-lmb-review-page]').textContent = labels.page.replace('__PAGE__', page).replace('__TOTAL__', pages);
      feed.setAttribute('aria-busy', 'false');
    };
    const load = () => {
      if (rows) { render(); return Promise.resolve(); }
      if (pending) return pending;
      feed.hidden = false;
      feed.setAttribute('aria-busy', 'true');
      status.textContent = labels.loading;
      retry.hidden = true;
      pending = (async () => {
        const ids = productId ? [productId] : readJson(section, '[data-lmb-review-products]', []);
        if (!ids.length) throw new Error('No review products');
        const all = [];
        for (let index = 0; index < ids.length; index += 3) {
          const batch = await Promise.all(ids.slice(index, index + 3).map((id) => fetchProduct(shop, String(id))));
          all.push(...batch.flat());
        }
        if (disposed) return;
        rows = all;
        if (!isHome && rows.length) {
          const rating = rows.reduce((sum, row) => sum + row.rating, 0) / rows.length;
          document.querySelectorAll('[data-lmb-review-badge]').forEach((badge) => {
            if (badge.dataset.lmbReviewBadge !== productId) return;
            badge.querySelector('[data-lmb-review-badge-rating]').textContent = `${rating.toFixed(2)} / 5`;
            badge.querySelector('[data-lmb-review-badge-count]').textContent = countText(rows.length);
            badge.querySelector('.lmb-review-overview__stars')?.style.setProperty('--lmb-rating-fill', `${rating * 20}%`);
          });
          const score = section.querySelector('.lmb-review-overview__score');
          if (score) {
            score.querySelector('strong').textContent = rating.toFixed(2);
            score.querySelector('.lmb-review-overview__stars')?.style.setProperty('--lmb-rating-fill', `${rating * 20}%`);
            const count = score.querySelector('p:last-child');
            if (count) count.textContent = countText(rows.length);
          }
        }
        render();
      })().catch(() => {
        if (disposed) return;
        status.textContent = labels.error;
        feed.setAttribute('aria-busy', 'false');
        retry.hidden = false;
        reset.hidden = !selected;
      }).finally(() => { pending = null; });
      return pending;
    };
    const select = (topic) => {
      selected = selected === topic ? '' : topic;
      page = 1;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.lmbReviewTopic === selected)));
      reset.hidden = !selected;
      if (isHome && !selected) { feed.hidden = true; native.hidden = false; return; }
      load();
    };
    const click = (event) => {
      const topic = event.target.closest('[data-lmb-review-topic]');
      if (topic && section.contains(topic)) select(topic.dataset.lmbReviewTopic);
      if (event.target.closest('[data-lmb-review-reset]')) select(selected);
      if (event.target.closest('[data-lmb-review-retry]')) load();
      if (event.target.closest('[data-lmb-review-previous]')) { page -= 1; render(); }
      if (event.target.closest('[data-lmb-review-next]')) { page += 1; render(); }
    };
    const change = () => { page = 1; render(); };
    let authorFrame = null;
    const authorScopes = new Set();
    const watchAuthors = () => authorObserver.observe(native, { childList: true, subtree: true, characterData: true });
    const refreshAuthors = () => {
      authorFrame = null;
      if (disposed) return;
      authorObserver.disconnect();
      authorScopes.forEach((scope) => { if (native.contains(scope) || scope === native) formatAuthors(scope); });
      authorScopes.clear();
      watchAuthors();
    };
    const authorObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest('.lmb-review-language')) return;
        authorScopes.add(target.closest('.jdgm-rev, .jdgm-carousel-item') || target);
      });
      if (authorScopes.size && authorFrame === null) authorFrame = requestAnimationFrame(refreshAuthors);
    });
    formatAuthors(native);
    watchAuthors();
    section.addEventListener('click', click);
    sort.addEventListener('change', change);
    let observer;
    if (!isHome) {
      observer = new IntersectionObserver((entries) => { if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); load(); } }, { rootMargin: '400px' });
      observer.observe(section);
    }
    instances.set(section, () => { disposed = true; disposeTopicDisclosure(); authorObserver.disconnect(); if (authorFrame !== null) cancelAnimationFrame(authorFrame); observer?.disconnect(); section.removeEventListener('click', click); sort.removeEventListener('change', change); instances.delete(section); });
  };
  const prepare = (section) => {
    if (instances.has(section) || waiting.has(section)) return;
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) { connect(section); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      waiting.delete(section);
      connect(section);
    }, { rootMargin: '600px' });
    waiting.set(section, observer);
    observer.observe(section);
  };
  const start = (scope) => {
    if (scope.matches?.('[data-lmb-review-filter]')) prepare(scope);
    scope.querySelectorAll('[data-lmb-review-filter]').forEach(prepare);
  };
  window.LmbReviewTopics = { start };
  document.addEventListener('shopify:section:load', (event) => start(event.target));
  document.addEventListener('shopify:section:unload', (event) => { instances.forEach((dispose, section) => { if (event.target.contains(section)) dispose(); }); waiting.forEach((observer, section) => { if (event.target.contains(section)) { observer.disconnect(); waiting.delete(section); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
})();



